// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"79":"release-notes","277":"mfp","536":"new","986":"regions"}[chunkId] + "." + {"79":"c3c9a893","277":"240274cc","536":"f397cc1e","986":"0d8abe6c"}[chunkId] + ".chunk.css";
};